import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable, from, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { catchError, mergeMap } from 'rxjs/operators';
import { LoggerService } from '../../logger/logger.service';
import { SessionStorageService } from '../../storage/session-storage/session-storage.service';
import { jwtDecode } from "jwt-decode";
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorsService implements HttpInterceptor {
  token: string;
  SCOPE:Array<string>;
  constructor(
    private router: Router,
    private loggerService: LoggerService,
    private sessionStorage : SessionStorageService,
    private msalService: MsalService,
  ) {
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!window.location.href.includes("logout") &&
      !req.url.includes(environment.FILE_SCAN_CONTAINER)
    ) { //When user is logged in

      if (req.url.indexOf(environment.GRAPH_URL) == -1) {
        // this does not seems like a valid log
        // removing this as this might be part of a cleanup task
        // for addtional infor refer this PR : https://dev.azure.com/Oracle-Ascend/Oracle-Ascend/_git/Oracle-Ascend-Test-AI-UI/commit/5d08ab395f0fbe0ac377917d126fca34b881471d
        let func = (environment.isLocal) ? 'readAuthToken' : 'getTokenFromMSAL';
        let this_ = this;
        return from(
          this[func](req.url)
            .then(function (token) {
              if (token != 'logout-token') {
                this_.sessionStorage.setValue('userDetails', {name : this_.getDecodedAccessToken(token).name, email : this_.getDecodedAccessToken(token).preferred_username});
                var JWT = "Bearer " + token;
                return req.clone({
                  setHeaders: {
                    Authorization: JWT,
                  },
                });
              }
              else {
                this.router.navigate(['/logout']);
              }
            })
        ).pipe(
          mergeMap(
            (req: any) => {
              return next.handle(req).pipe(
                catchError((err) => {
                  this.loggerService.log(err)
                  if (err instanceof HttpErrorResponse && err.status == 401) {
                    console.error('ACTION TODO: SHOW A GENERIC 401 MODAL');
                  }
                  return throwError(()=>err);
                })
              );
            }
          )
        )

      } else {
        return next.handle(req).pipe(
          catchError((err) => {
            return throwError(()=>err);
          })
        )
      }
    }
    
    if (req.url.includes(environment.FILE_SCAN_CONTAINER)) {
      return next.handle(req);
    }
  }

  private async readAuthToken(url): Promise<any> {
    return new Promise((resolve, reject) => {
      let token = localStorage.getItem('auth-token');
      resolve(token);
    })
  }

  private async getTokenFromMSAL(url): Promise<any> {
    return new Promise(async (resolve, reject) => {
      if (url.indexOf('/logout') > -1) {
        resolve('logout-token');
      }
      if (url.indexOf('graph.microsoft.com') > -1)
        this.SCOPE = ["user.read"];

      const account = await this.msalService.instance.getActiveAccount()
        if (account) {
          await this.msalService.instance.acquireTokenSilent({ scopes: this.SCOPE, account })
            .then(token => {
              resolve(token.idToken);
            })
            .catch(err => {
              // could also check if err instance of InteractionRequiredAuthError if you can import the class.
              this.loggerService.log('error details ' + err);
              // || err instanceof this.msalService.instance.InteractionRequiredAuthError
              if (err.name === "InteractionRequiredAuthError") {
                this.msalService.instance.acquireTokenPopup({ scopes: this.SCOPE })
                  .then(token => {
                    // get access token from response
                    resolve(token.idToken);
                  })
                  .catch(err => {
                    console.error(`401 - Couldn't fetch access token!`);
                    reject('401');
                  });
              }
            });
        } else {
          console.error('401- Could not fetch access-token, login the user', url);
          reject('401')
        }

    })
  }

  private getDecodedAccessToken(token: string): any {
    try {
      return jwtDecode(token);
    } catch(Error) {
      return null;
    }
  }
}

